<template>
  <div class="animated fadeIn list-of-pr">
    <b-card>
      <div slot="header">Inventory Issued(CR) Posting Group
        <div class="card-header-actions">
          <b-form-radio-group  v-model="viewOption">
              <b-form-radio v-model="viewOption" value="Header">View Header</b-form-radio>
              <b-form-radio v-model="viewOption" value="Lines">View Line/Items</b-form-radio>
          </b-form-radio-group>                  

          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm" >Delete</b-button>
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="primary mr-1" @click="togleFilter()"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="5">
            <b-input-group >
              <b-input-group-prepend><span>Issued/usage Group Name</span></b-input-group-prepend>
              <b-form-input v-model="tblData.issueGrpname" ></b-form-input>
            </b-input-group>
        </b-col>
        <b-col lg="6">
            <b-input-group>
              <b-input-group-prepend><span>Inventory Category</span></b-input-group-prepend>
              <b-form-input v-model="tblData.nmcategory" placeholder="Head Category"></b-form-input>
            <b-input-group-append>
              <b-button class="btn btn-success ml-3" @click="search()">
                <i class="fa fa-refresh"></i> Apply Filter
              </b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button class="btn btn-secondary ml-1" @click="clearFilter()">
                <i class="fa fa-eraser"></i>Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>

      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"  @row-clicked="rowClicked"
        show-empty 
      >
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#"  style="padding:0 !important;">Edit</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#"  style="padding:0 !important;"> Delete</b-dropdown-item>
        </b-dropdown>
      </template>        
        <template v-slot:cell(sales)="data">
          <span v-if="data.item.sales==1">Sales</span>
        </template>
        <template v-slot:cell(lostbroken)="data">
          <span v-if="data.item.lostbroken==1">Yes</span>
        </template>
        <template v-slot:cell(kodeacc)="data">
          <span v-if="(data.item.kodeacc)"> {{data.item.kodeacc}} | {{data.item.namaacc}}  </span>    
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page"  style="margin-top:0 !important;">
            <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal v-model="showForm" header-bg-variant="primary" size="lg" title="Add/Edit Inventory Issued Group" :centered="true" @ok="save" ok-title="Save">
      <b-row>
        <b-col md=6>
          <b-input-group class="pr-1">
              <b-input-group-prepend><label>Group Name</label></b-input-group-prepend>
              <b-form-input v-model="frmdata.issueGrpname" :state="!$v.frmdata.issueGrpname.$error"></b-form-input>  
          </b-input-group>
          <b-input-group class="pr-1">
              <b-input-group-prepend><label>Group Flag</label></b-input-group-prepend>
              <b-form-checkbox v-model="frmdata.sales" :value="1" :unchecked-value="0"  class="pt-2">Trading/Sales</b-form-checkbox>
              <b-form-checkbox v-model="frmdata.lostbroken" :value="1" :unchecked-value="0"  class="ml-2 pt-2">Lost/Broken/Expired</b-form-checkbox>
          </b-input-group>
        </b-col>
        <b-col md=6>
          <v-dim :model="frmdata" :key="model.issueGrpkey"></v-dim>                  
        </b-col>
      </b-row>
      <b-card class="mt-1">
        <b-input-group>
            <b-input-group-prepend><span class="pt-2 pr-1">Inventory Acc.(CR) </span></b-input-group-prepend>
            <b-form-select v-model="frmdata.inven_catid" :plain="true" :options="headCategories" size="sm"></b-form-select>
            <b-input-group-prepend><span class="p-2" >DB Acc.</span></b-input-group-prepend>
            <b-form-input readonly v-model="frmdata.kodeaccinfo"  style="width:20% !important;"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuCoaShow=true" ><i class="fa fa-search"></i></b-btn>
            </b-input-group-append>
            <b-input-group-append><b-button class="ml-1 btn btn-success" @click="addGroupLines()" > <i class="fa fa-plus-circle"></i> Add</b-button></b-input-group-append>
        </b-input-group>
        <b-table
            class="mb-0"
            ref="tblGroupLines"
            outlined
            striped hover small
            style="font-size:smaller;"
            :items="groupLines.items"
            :fields="groupLines.fields"
            show-empty
            >
                <template v-slot:cell(index)="data">
                    {{data.index + 1}}
                </template>
                <template v-slot:cell(action)="data">
                    <div class="text-center">
                    <a href="javascript:void(0)" class="text-danger" @click="delGroupLines(data.index)">
                        <i class="fa fa-trash"></i>
                    </a>
                    </div>
                </template>
            <template v-slot:cell(empty)="scope">
                <h4>{{ scope.emptyText }}</h4>
            </template>
            <template v-slot:cell(emptyfiltered)="scope">
                <h4>{{ scope.emptyFilteredText }}</h4>
            </template>                        
        </b-table>
      </b-card>
    </b-modal>
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
        </b-modal>        

  </div>
</template>
<style lang="scss">
  .list-of-pr {

    table {
      td:nth-child(1) {
        width: auto;
      }
      td:nth-child(2) {
        width: auto;
      }
      td {
        .dropdown-item {
            padding: 0.1rem 1.5rem !important;
            font-size: smaller !important;
        }    
      }
    }
  }

</style>
<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import pr from "../../apis/logistic_inv_out_group";
import vDim from "../lookup/dim";
import lkuCoa from "../lookup/lkuCoa";
import { validationMixin } from "vuelidate";
import { required, minValue,numeric } from "vuelidate/lib/validators";
import toastr from "mini-toastr";
toastr.init();

export default {
  components: {Loading, vDim, lkuCoa},
  mixins: [validationMixin],
  validations: {
        frmdata: {
          issueGrpname: { required },
        },
  },

  data() {
    return {
      viewOption:'Lines',
      showForm:false,  
      showFilter: false,
      showDelConfirm: false,
      lkuCoaShow:false,
      lkuCoaCaller:'',
      isLoading:false,
      showReport:false,
      reportUrl: null,
      tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
      model:{},
      frmdata: {issueGrpname:'', sales:0, lostbroken:0, kodeacc:'', namaacc:''},
      headCategories:[],
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        sortBy: 'issueGrpname',
        sortDesc: false,
        DimCol:'Dim1'
      },
      tblFields: [
          {
            key: "action",
            label: "",
            thStyle: "width:40px",
            thClass: "text-center",
          },
          {
            key: "issueGrpname",
            label: "Issued Group Name",
            sortable: true
          },
          {
            key: "sales",
            label: "Sales",
            thStyle: "width:80px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "lostbroken",
            label: "Broken /Loss",
            thStyle: "width:70px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "namaheadcategory",
            label: "Inventory Category",
            sortable: true
          },          
          {
            key: "kodeacc",
            label: "DB/Cost Account",
            sortable: true
          },
      ],
      groupLines: {
          items: [],
          page: 1,
          limit: 25,
          total: 0,
          fields:[
            {
              key: "index",
              label: "No.",
              thStyle: "width:30px",
              thClass: "text-center",
            },
            {
              key: "namaheadcategory",
              label: "Inventory Name (CR)",
              sortable: true
            },         
            {
              key: "invKodeacc",
              label: "Inventory Acc.",
              sortable: true
            },          
            {
              key: "kodeacc",
              label: "DB Account#",
             thStyle: "width:100px",
              sortable: true
            },            
            {
              key: "namaacc",
              label: "DB/Cost Account Name",
              sortable: true
            },            
          {
            key: "action",
            label: "",
            thStyle: "width:40px",
            thClass: "text-center",
          },
          ],
      },

    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    invalidFrmdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },

  },
  watch:{
    dimCol: function(newval) {
        this.tblData.DimVal="";
        this.tblData.DimValInfo="";
        this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
    viewOption : function(newval) {
      if (newval=='Header') {
        this.tblFields=[
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },
          {
            key: "issueGrpname",
            label: "Issued Group Name",
            sortable: true
          },
          {
            key: "sales",
            label: "Sales",
            thStyle: "width:80px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "lostbroken",
            label: "Broken",
            thStyle: "width:80px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
        ];
      } else {
        this.tblFields= [
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },
          {
            key: "issueGrpname",
            label: "Issued Group Name",
            sortable: true
          },
          {
            key: "sales",
            label: "Sales",
            thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "lostbroken",
            label: "Broken",
            thStyle: "width:80px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "namaheadcategory",
            label: "Inventory Category",
            sortable: true
          },          
          {
            key: "kodeacc",
            label: "DB/Cost Account",
            sortable: true
          },
        ];
      }
      const dims = this.$store.state.dimension;
      for (let i = 0; i < dims.length; i += 1) {
        this.tblFields.push( {
          key: `${dims[i].value}Txt`,
          // thStyle: "width:80px",
          label: dims[i].text,
          sortable: true
        },)
      }

      this.refresh();
    },
  },
  created: async function(){
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          this.tblFields.push(          {
            key: `${dims[i].value}Txt`,
            // thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }
        const [a,b] = await Promise.all([pr.inventorygroup(),pr.group()]) ;
        this.headCategories = a; 
        this.itemCategories = b; 

  },
  methods: {
   data: async function(ctx) {
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.invoutgrp) {
            this.tblData[key] = filter.invoutgrp[key];
            filtered=true;
        }
        if (filtered === true) {
          this.tblData.tgl1=filter.invoutgrp.tgl1 || '';
          this.tblData.tgl2=filter.invoutgrp.tgl2 || '';
          this.showFilter=filtered;
          delete filter.invoutgrp;
          this.$store.commit("filter", filter);
        }
      this.isLoading=true;
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      let list;
      if (this.viewOption=='Header') {
          list = await pr.listheader(this.tblData);
      } else {
          list = await pr.list(this.tblData);
      }
      this.isLoading=false;
     return list;
    },
    search(ctx) {
      this.tblData.page=1;
      this.$refs.table.refresh();
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.issueGrpname=  '';
        this.tblData.nmcategory=  '';
    },
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();
    },
    add(){
          // for (var key in this.frmdata) {
          //     this.frmdata[key] = '';
          // }
          this.frmdata.issueGrpkey='';
          this.frmdata.issueGrpname='';
          this.groupLines.items=[];
          this.showForm=true;
    },
    edit: async function() {
        if (this.model.issueGrpkey) {
            this.groupLines.items =  await pr.detail(this.model);

            // for (var key in this.frmdata) {
            //     this.frmdata[key] = '';
            // }
            for (var key in this.model) {
                this.frmdata[key] = this.model[key];
            }

          this.showForm=true;
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    addGroupLines: function() {
      const ada = this.headCategories.find(c => c.value==this.frmdata.inven_catid);
      if (ada){
        this.groupLines.items.push({
          inven_catid: this.frmdata.inven_catid,
          invKodeacc: this.frmdata.kodeacc,
          headcategory: this.frmdata.kodeacc,
          namaheadcategory: ada.text,
          kodeacc: this.frmdata.kodeacc,
          namaacc: this.frmdata.namaacc
        });
        this.groupLines.total=this.groupLines.items.length;

      }
    },
    delGroupLines: function (index) {
        const _selected = this.groupLines.items[index];
        this.$bvModal.msgBoxConfirm(`${_selected.namaheadcategory}`, {
          title: 'Delete Confirm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
          .then(value => {
            if (value == true) {
                if (index > -1) {
                  // this.groupLines.items.splice(index, 1);
                  const posisi = (this.groupLines.page-1)*this.groupLines.limit;
                  this.groupLines.items.splice(posisi+index, 1);
                }
                this.groupLines.total=this.groupLines.items.length;
            }
          })
          .catch(err => {
            console.log(err);
            // An error occurred
          })

    },
    save: async function(evt) {
      evt.preventDefault()
        if (this.invalidFrmdata) {
          toastr.error('Please fill the form correctly.')
            return;
        }
        this.showForm = false;
        try {
          const row = {};
          for (var key in this.frmdata) {
              row[key] = this.frmdata[key];
          }
          row.lines = this.groupLines.items;
          //  row.lines = this.groupLines.items.reduce((newArr, item) => item, []);
          //  console.log
          if (row.lines.length>0) {
            await pr.save(row);
            this.saveEnabled= true;
            this.showForm = false;
            this.refresh();
          } else {
            toastr.error('Please fill at least 1(one) Inventory Issued Detail', 'ERROR MESSAGE');
            this.showForm = true;
          }
        } catch (error) {
            console.log('save : ', error)
            this.showForm = true;
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
        }
    },

    onSelectLkuCoa(_selected) {
        this.frmdata.kodeaccinfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
        this.frmdata.kodeacc = _selected.kodeacc;
        this.frmdata.namaacc = _selected.namaacc;
        this.lkuCoaShow=false;
    },
    deleteConfirm() {
        if (this.model.issueGrpkey) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      try {
          if (this.viewOption=='Header') {
              await pr.remove(this.model);
              this.refresh();
          } else {
              await pr.removeLine(this.model);
              this.refresh();
          }
        } catch (error) {
            // this.saveEnabled=true;
            // this.isLoading=false;
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
        }
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            let response;
              response= await pr.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    close(){
      router.push("/logistic/home");
    },    
  }
};
</script>
